import { Breakpoints, css, styled, ThemeDefinition } from '@volkswagen-onehub/components-core';

interface ListItemStyledProps {
  active: boolean;
  ciGuidelinesRollout: boolean; 
  theme: ThemeDefinition;
}

export const ListItemStyled = styled.div<{ theme: ThemeDefinition }>`
  ${({ active, ciGuidelinesRollout, theme }: ListItemStyledProps) => {
    return css`
      align-items: center;
      border-radius: ${theme.size.borderRadius.medium};
      cursor: pointer;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin: ${theme.size.static100} 0;
      padding: ${theme.size.static300} ${theme.size.static150};
      text-align: left;
      transition: background-color 400ms linear, transform 400ms linear;
      vertical-align: middle;

      @media (min-width: ${Breakpoints.b1280}px) {
        padding: ${theme.size.static300} ${theme.size.static200};
      }

      ${active && css`
        background-color: ${ciGuidelinesRollout ? theme.colors.background.highlight : theme.colors.background.secondary};
        ${ciGuidelinesRollout && css`border: ${theme.size.border.active} solid ${theme.colors.border.hover};`}
      `}

      &:active {
        background-color: ${ciGuidelinesRollout ? theme.colors.background.highlight : theme.colors.background.secondary};
        ${ciGuidelinesRollout && css`border: ${theme.size.border.active} solid ${theme.colors.border.hover};`}
      }

      &:hover {
        background-color: ${ciGuidelinesRollout ? theme.colors.background.highlight : theme.colors.background.tertiary};
      }

      &:focus-visible {
        background-color: ${ciGuidelinesRollout ? theme.colors.background.highlight : theme.colors.background.secondary};
        border: ${theme.size.border.focus} solid ${theme.colors.border.hover};
      }
    `;
  }}
`;

export const ListItemContentStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
`;

export const ListItemActionStyled = styled.div`
  span {
    z-index: 0;
  }
`;
